import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { User } from '../../model/user';
import { plainToClass } from 'class-transformer';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";
import { SharedMethods } from '../../../../util/sharedMethods-service';



@Injectable()
export class UserApiService {

  users: User[];

  iSconnecting: boolean = false;

  // caisse: Compte;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
              ) { }

    getOneUser(iduser: number) {

      this.iSconnecting = true;
      return new Promise<User>(resolve => {
          this.http.get(this.apiEndpoints.URL_GET_USER(iduser),
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: User) =>  {
                const user = plainToClass(User, data as object);
                /* for ( let i = 0; i < factures.length; i++) {
                  factures[i].fluxstock = plainToClass(FluxStock, factures[i].fluxstock);
                  factures[i].reglements = plainToClass(Reglement, factures[i].reglements);
                } */
                resolve(user);
                this.iSconnecting = false;
              },
              err => {
                // console.log(err);
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                this.iSconnecting = false;
              });
      });
  
    }

  getUsers() {
    this.iSconnecting = true;
    return new Promise<User[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_USERS(),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: User[]) => {
            const users = plainToClass(User, data);
            this.users = users;
            resolve(users);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
          });
    });
  }


  saveUser(user: User) {

    this.iSconnecting = true;

    this.iSconnecting = true;

    let userdata: any;

    if (user.password !== undefined && user.password !== null && user.password !== '') {

      userdata = {
        name: user.name,
        username: user.username,
        email: user.email,
        // roles: user.roles,
        permissions: user.permissions,
        isActive: user.is_active,
        plainPassword: user.password,
        companyId: 1,
      };

    } else {

      userdata = {
        name: user.name,
        username: user.username,
        email: user.email,
        // roles: user.roles,
        permissions: user.permissions,
        isActive: user.is_active,
        companyId: 1,
      };

    }


    if (user.id !== 0) {

      return new Promise<User>(resolve => {
        this.http.patch(this.apiEndpoints.GET_URL_PATCH_USERS(user.id), userdata,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: User) => {

              this.getUsers();
              resolve(data);
              this.iSconnecting = false;

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }else {

      return new Promise<User>(resolve => {
        this.http.post(this.apiEndpoints.GET_URL_POST_USERS, userdata,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: User) => {

              this.getUsers();
              resolve(data);
              this.iSconnecting = false;

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }



  }

  deleteUser(id: number) {

    this.iSconnecting = true;
    return new Promise(resolve => {
      this.http.delete(this.apiEndpoints.GET_URL_DELETE_USERS(id),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {
            this.getUsers();
            resolve(data);
            this.iSconnecting = false;
          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
          });
    });

  }

  updateSolde(partnerId: number, newsolde: number) {
    this.iSconnecting = true;
    return new Promise(resolve => {
      this.http.get(this.apiEndpoints.GET_URL_UPDATE_SOLDE_USER(partnerId, newsolde),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {
            
              resolve(data);
              this.iSconnecting = false;

          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
          });
    });


  }


}
